import { IUser } from "../interfaces/user";
import { get } from "../util/api";
import { withMalformedApiResponseError } from "../util/custom-errors";

export const fetchUser = async (token: string): Promise<IUser> => {
  const url = `${process.env.HOST_ENV}/user/v1/user/sdk/getUser`;
  const res = await get<{ success: boolean; data: { user: IUser } }>(
    url,
    token
  );
  const body = res.parsedBody;
  if (!res || !body || !body.success || !body.data || !body.data.user)
    throw withMalformedApiResponseError(
      "error fetching user",
      {
        url,
        method: "get",
      },
      res
    );
  if (body.data.user) return body.data.user;
};
